module.exports = [
  '$rootScope',
  '$translate',
  '$ionicActionSheet',
  '$state',
  '$ionicListDelegate',
  'MailFolderType',
  '$utils',
  'User',
  function ($rootScope, $translate, $ionicActionSheet, $state, $ionicListDelegate, MailFolderType, $utils, User) {
    return {
      restrict: 'E',
      replace: true,
      scope: false,
      template: require('views/mail/message-item.html'),
      link: function (scope, elem, attr) {
        const msgHandlerDelegate = scope.msgHandlerDelegate
        const keywordSearchMail = scope.keywordSearchMail || {}
        // 搜索列表传入mboxa
        const mboxa = scope.tempModal && scope.tempModal._isShown ? keywordSearchMail.mboxa : undefined
        const isMailDealings = $state.current.name === 'frame.maildealings'
        const _mboxa = isMailDealings ? '' : (mboxa === '' ? '' : mboxa || User.getSelectedAccountSymbol())
        scope.messageInfo = scope.msgItem.messageInfo
        if (scope.msgItem.messageInfo.fid === 3) {
          scope.recevierList = formatRecevier(scope.msgItem.messageInfo.to)
        }
        const flags = scope.messageInfo.flags
        if (scope.searchModalOpen) {
          scope.msgItem.messageInfo.folderName = getFolderName(scope.messageInfo.fid)
        }
        $ionicListDelegate.closeOptionButtons()

        scope.$on('RESET_SELECT_ITEM', function () {
          scope.msgItem.messageInfo.isChecked = false
        })

        scope.mark = function (sFlag, bValue, event) {
          if (sFlag === 'flagged') {
            if (bValue) {
              LA.track('A1C201')
            } else {
              LA.track('A1C202')
            }
          } else if (sFlag === 'read') {
            if (bValue) {
              LA.track('A1C105')
            } else {
              LA.track('A1C106')
            }
          }
          _closeOptionButtons()
          event && event.preventDefault()
          event && event.stopPropagation()
          scope.msgItem.mark(sFlag, bValue, null, _mboxa).then(function () {
            // 切换旗帜状态之后，应该给这个 item 一个标识，进入详情页面的时候可以刷新页面，不使用缓存的页面
            scope.msgItem.isFlagChanged = true
          })
        }

        scope.removeMessage = function () {
          if (msgHandlerDelegate.removeMessages) {
            LA.track('A1C3')
            msgHandlerDelegate.removeMessages([scope.msgItem], _mboxa)
          }
          if (scope.tempModal) {
            scope.$parent.closeSearchModal()
          }
        }

        scope.showActionSheet = function (event) {
          event && event.preventDefault()
          event && event.stopPropagation()
          LA.track('A1C1')
          const wrapperText = function (content) {
            return '<p class="actionText">' + $translate.instant(content) + '</p>'
          }
          const wrapperOperation = function (type) {
            return function () {
              switch (type) {
                case 'reply':
                  LA.track('A1C101')
                  break
                case 'replyAll':
                  LA.track('A1C102')
                  break
                case 'forward':
                  LA.track('A1C103')
                  break
              }
              if (scope.tempModal) {
                scope.tempModal.hide()
              }

              const messageInfo = scope.msgItem.messageInfo
              $state.go('frame.compose', {
                action: type,
                mid: messageInfo.id || messageInfo.mid,
                mboxa: _mboxa
              })
            }
          }

          /** 当邮件处于只读状态时，只显示移动/已读/未读操作 */
          /** only show operations of moving or marking read/unread status when the message item is read only */
          const replyAndForwardSheet = [{
            text: wrapperText('OP.REPLY'),
            clickedFunc: wrapperOperation('reply')
          }, {
            text: wrapperText('OP.REPLY_ALL'),
            clickedFunc: wrapperOperation('replyAll')
          }, {
            text: wrapperText('OP.FORWARD'),
            clickedFunc: wrapperOperation('forward')
          }
          ]
          const mboxId = mboxa ? parseInt(mboxa.split('@')[1]) : undefined
          // 当前账号的权限
          const currentAccountAccess = mboxa === '' ? -1 : (mboxId ? User.getAccountAccessById(mboxId) : User.getSelectedAccountAccess())
          const sheet = (flags.webReadOnly ? [] : (currentAccountAccess === 2 ? replyAndForwardSheet : replyAndForwardSheet.concat([
            {
              text: wrapperText('OP.MOVE_TO'),
              clickedFunc: function () {
                if (msgHandlerDelegate.moveMessage) {
                  LA.track('A1C104')
                  msgHandlerDelegate.moveMessage(scope.msgItem, _mboxa)
                }
                if (scope.tempModal) {
                  scope.$parent.closeSearchModal()
                }
              }
            }, {
              text: wrapperText(flags.read ? 'OP.MARK_UNREAD' : 'MAIL.MARK_AS_READ'),
              clickedFunc: function () {
                scope.mark('read', !flags.read, null, _mboxa)
                if (scope.tempModal) {
                  scope.$parent.closeSearchModal()
                }
              }
            }
          ]))
          )
          $ionicActionSheet.show({
            buttons: sheet,
            cancelText: '取消',
            buttonClicked: function (index) {
              _closeOptionButtons()
              sheet[index].clickedFunc()
              return true
            }
          })
        }

        scope.toggleSelect = function (msgItem, read) {
          // 更改未读状态(主账号和代理的的共享账号才有权限更改)
          const mboxId = mboxa ? parseInt(mboxa.split('@')[1]) : undefined
          const accessNum = mboxa === '' ? -1 : (mboxId ? User.getAccountAccessById(mboxId) : User.getSelectedAccountAccess())
          const hasAccess = accessNum === -1 || accessNum === 1
          // 只读的共享账号无权限打开草稿箱邮件
          if (msgItem.messageInfo.flags && msgItem.messageInfo.flags.draft && accessNum === 0) {
            $utils.$notify.set({ message: $translate.instant('SETTING.SHARED_MAILBOX.NO_PERMISSION_TO_OPERATE') })
            return
          }
          if (!msgItem.messageInfo.flags.read && !scope.isSelectMode && hasAccess) {
            msgItem.mark('read', true, null, mboxa).then(function () {
              msgItem.messageInfo.flags.read = true
            })
          }
          if (_closeOptionButtons()) {
            return false
          }
          if (scope.isSelectMode) {
            msgItem.messageInfo.isChecked = !msgItem.messageInfo.isChecked
            msgHandlerDelegate.data = msgHandlerDelegate.data || {}
            if (msgItem.messageInfo.isChecked) {
              msgHandlerDelegate.data[scope.msgItem.messageInfo.id] = scope.msgItem
            } else {
              delete msgHandlerDelegate.data[scope.msgItem.messageInfo.id]
            }
          } else {
            scope.msgHandlerDelegate.readMessage(msgItem, _mboxa)
          }
        }
        // 格式化收件人
        function formatRecevier(recevierStr) {
          const formatRecevierList = []
          const iRecevierStr = recevierStr.replace(/，/g, ',')
          const contactList = iRecevierStr.split(',')
          contactList.forEach(function (contact) {
            const hasName = contact.indexOf('"') !== -1
            let recevierName = ''
            let recevierEmail = ''
            if (hasName) {
              recevierName = $utils.$email.parseTrueName(contact)
              recevierEmail = $utils.$email.parse(contact).addr
            } else {
              recevierName = ''
              recevierEmail = contact
            }
            const temp = {
              name: recevierName,
              email: recevierEmail
            }
            formatRecevierList.push(temp)
          })
          return formatRecevierList
        }
        function getFolderName(fid) {
          let foldername = ''
          Object.keys(MailFolderType).forEach(function (key) {
            if (MailFolderType[key] == fid) {
              foldername = '[' + $translate.instant('MAIL.FOLDER.' + key.toUpperCase()) + ']' + ' '
            }
          })
          return foldername
        }

        function _closeOptionButtons() {
          const eleList = elem.parent()[0]
          const swipeEle = eleList.querySelectorAll('.item-options:not(.invisible)')
          if (swipeEle && swipeEle.length > 0) {
            $ionicListDelegate.closeOptionButtons()
            return true
          } else {
            return false
          }
        }
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/messageItem.js